import clsx from 'clsx';
import { ReactNode } from 'react';

export interface Props {
  text: string;
  children: ReactNode;
  position?:
    | 'top'
    | 'top-right'
    | 'right'
    | 'bottom-right'
    | 'bottom'
    | 'bottom-left'
    | 'left'
    | 'top-left';
  always?: boolean;
  visible?: boolean;
  rounded?: boolean;
  noShadow?: boolean;
  colorModifier?: 'error' | 'warning' | 'info' | 'success';
  size?: 'small' | 'medium' | 'large';
  nowrap?: boolean;
}

export function Tooltip(props: Props) {
  const {
    text,
    children,
    position = 'top',
    always = false,
    visible,
    rounded = true,
    noShadow = true,
    colorModifier,
    size,
    nowrap = false,
  } = props;

  return (
    <span
      className={clsx(
        nowrap
          ? 'hover:after:whitespace-nowrap hover:after:content-[attr(aria-label)]'
          : 'hover:after:whitespace-pre-line hover:after:content-[attr(aria-label)]',
        'before:border',
        'after:rounded-md after:border after:shadow-lg',
        ' after:border-onlight-bg-3 dark:after:border-ondark-bg-3',
        'after:dark:bg-ondark-bg-1 after:bg-onlight-bg-1 after:dark:text-ondark-text-1 after:text-onlight-text-2 after:dark:ring-ondark-bg-1 after:ring-onlight-bg-1 after:ring-1 after:ring-opacity-10',
        `hint--${position}`,
        (always || visible) && 'hint--always',
        rounded && 'hint--rounded',
        noShadow && 'hint--no-shadow',
        colorModifier && `hint--${colorModifier}`,
        size && `hint--${size}`,
        'rounded-md p-1 hover:bg-slate-200 dark:hover:bg-slate-700'
      )}
      aria-label={text}
    >
      {children}
    </span>
  );
}

export default Tooltip;
